export default __webpack_public_path__ + "static/media/Animals2_12.0bbe6b45.png";